import { InstagramEmbed } from 'react-social-media-embed';

import "../app/App.css";

function InstagramDisplay() {
    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <InstagramEmbed url="https://www.instagram.com/reel/CtnzT1Tumev/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" width={328} />
            </div>
        </div>
    )
}

export default InstagramDisplay;